export default __webpack_public_path__ + "static/generic-e7c6b92f48691941f07d23e801002cfe.jpg";